export default __webpack_public_path__ + "static/MyRobotics-0d183dfd418552ace76875af97a999b0.png";